import { call } from "redux-saga/effects";

import { authApiService } from "../../../../actionService/apiService";

import endPoints from "./user.endpoints";

import { LoginRequestDto } from "./user.requestsDto";

import { ApiCallResult } from "../../../../types";
import { UserInfoDto } from "../../../../../dto/User/UserInfoDto";
import { IUserBasicInfoDto } from "../../../../../dto/User/IUserBasicInfoDto";
import { UserTypes } from "../../../../../dto/User/UserTypes";

const authUserApi = {
  login: function* (dto: LoginRequestDto) {
    return (yield call([authApiService, authApiService.Post], endPoints.login, dto)) as ApiCallResult<UserInfoDto>;
  },
  getBasicInfo: function* (userType: UserTypes) {
    return (yield call([authApiService, authApiService.Get], endPoints.basicInfo, userType)) as ApiCallResult<Array<IUserBasicInfoDto>>;
  },
};

export default authUserApi;
